import React, { useContext, useEffect, useRef } from 'react';

import { Chat, ChatContext } from '../../../../../chat';
import ChatMessage from '../../../../../chat/Model/ChatMessage';
import FirebaseContext from '../../../../../context/FirebaseContext';
import ChatLoadingView from '../../components/ChatLoadingView';
import useSessionStore from '../../../../../hooks/useSessionStore';
import UserContext from '../../../../../context/UserContext';
import { getQueryVariable } from '../../../../../utils/queryParams';
import WebMediaRecorder from '../../WebMediaRecorder';

const ChatContainer = React.memo(() => {
  const {
    isReady,
    setActiveChannelId,
    setFocusMessageId,
  } = useContext(ChatContext);

  const { firebase } = useContext(FirebaseContext);

  const { userId: chatUserId } = useContext(UserContext);

  const sessionStore = useSessionStore();

  const webMediaRecorder = new WebMediaRecorder();

  const hasHandledFocusRef = useRef(false);

  useEffect(() => {
    const focusFlaggedMessage = async () => {
      const focusMessageId = getQueryVariable('focusMessageId');
      if (!focusMessageId || hasHandledFocusRef.current) {
        return;
      }
      hasHandledFocusRef.current = true;

      try {
        const message = await ChatMessage.getById(focusMessageId);
        if (message?.channelId) {
          setActiveChannelId(message.channelId);
          setFocusMessageId(focusMessageId);
        }
      } catch (error) {
        // Message not found or inaccessible — fall back to opening chat normally, no focus.
      }
    };

    if (isReady) {
      focusFlaggedMessage();
    }
  }, [isReady, setActiveChannelId, setFocusMessageId]);

  if (!isReady) {
    return <ChatLoadingView />;
  }

  return (
    <Chat
      firebase={firebase}
      sessionStore={sessionStore}
      chatUserId={chatUserId}
      mediaRecorder={webMediaRecorder}
      parentApp="web"
    />
  );
});

export default ChatContainer;
